// extracted by mini-css-extract-plugin
export default {"container":"bridge_container__WkNV4","title":"bridge_title__EKAn7","text":"bridge_text__MEh1o"};